const MISSION_CARD_NAME_INPUT_SELECTOR = '.mission-card__name-input';

function collapseMissionCardNameInputs(root) {
  root.querySelectorAll(MISSION_CARD_NAME_INPUT_SELECTOR).forEach((input) => {
    try {
      if (input.selectionStart != null && input.selectionEnd != null) {
        input.setSelectionRange(0, 0);
      }
    } catch {
      // setSelectionRange can throw on disconnected nodes
    }
  });
}

/**
 * Blur editable fields and collapse any lingering text selection in mission card
 * titles (Ctrl+A + click-away leaves a visible highlight on unfocused textareas).
 */
export function clearFlowchartTextSelections(root = document) {
  // Collapse while still focused — before blur/save can re-trigger a select-all.
  collapseMissionCardNameInputs(root);

  const activeEl = document.activeElement;
  if (
    activeEl
    && (activeEl.tagName === 'INPUT'
      || activeEl.tagName === 'TEXTAREA'
      || activeEl.isContentEditable)
  ) {
    activeEl.blur();
  }

  collapseMissionCardNameInputs(root);

  if (typeof window !== 'undefined' && typeof window.getSelection === 'function') {
    const sel = window.getSelection();
    if (sel && sel.rangeCount > 0 && !sel.isCollapsed) {
      sel.removeAllRanges();
    }
  }

  if (typeof requestAnimationFrame === 'function') {
    requestAnimationFrame(() => collapseMissionCardNameInputs(root));
  }
}
